import React, { useState, useEffect } from "react";
import { Modal, Select, Form, Spin } from "antd";
import { fetchAdminPackages, get_all_tests } from "../../endpoints/API";

const { Option } = Select;

function AddOrderItemModal({ visible, onClose, clientId, onAdd, familyMembers, createdBy }) {
    const [loading, setLoading] = useState(false);
    const [tests, setTests] = useState([]);
    const [packages, setPackages] = useState([]);
    const [form] = Form.useForm();

    // Fetch all tests and packages
    const fetchData = async () => {
        setLoading(true);
        try {
            const [tRes, pRes] = await Promise.all([get_all_tests(), fetchAdminPackages()]);

            // Flatten tests array if needed
            const flatTests = tRes.data || [];

            // Packages array
            const allPackages = pRes?.data?.packages || [];

            console.log(allPackages)
            setTests(flatTests);
            setPackages(allPackages);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (visible) fetchData();
    }, [visible]);

    const handleSubmit = () => {
        form.validateFields().then(values => {
            onAdd({
                ...values,
                created_by: createdBy,
                status: "enable",
            });
            form.resetFields();
            onClose();
        });
    };

    // Watch form fields
    const orderType = Form.useWatch("order_type", form);
    const selectedTests = Form.useWatch("tests", form);
    const selectedPackages = Form.useWatch("packages", form);

    // Disable opposite fields
    const disableTests = orderType === "package" || (selectedPackages && selectedPackages.length > 0);
    const disablePackages = orderType === "test" || (selectedTests && selectedTests.length > 0);

    // Clear opposite field when selecting
    const handleOrderTypeChange = value => {
        if (value === "test") form.setFieldsValue({ packages: [] });
        else if (value === "package") form.setFieldsValue({ tests: [] });
    };

    const handleTestsChange = value => {
        if (value.length > 0) form.setFieldsValue({ packages: [] });
    };

    const handlePackagesChange = value => {
        if (value.length > 0) form.setFieldsValue({ tests: [] });
    };

    return (
        <Modal
            title="Add Order Item"
            open={visible}
            onCancel={onClose}
            onOk={handleSubmit}
            okText="Add"
        >
            {loading ? (
                <Spin />
            ) : (
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Family Member"
                        name="familymember"
                        rules={[{ required: true, message: "Please select a family member" }]}
                    >
                        <Select placeholder="Select Family Member">
                            {familyMembers?.map(fm => (
                                <Option key={fm.id} value={fm.id}>
                                    {`${fm.first_name} ${fm.middle_name} ${fm.last_name} (${fm.family_member_type.name})`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Order Type"
                        name="order_type"
                        rules={[{ required: true, message: "Please select order type" }]}
                    >
                        <Select
                            placeholder="Select Order Type"
                            onChange={handleOrderTypeChange}
                        >
                            <Option value="test">Test</Option>
                            <Option value="package">Package</Option>
                        </Select>
                    </Form.Item>

                    {/* Multi-select Tests */}
                    <Form.Item label="Tests" name="tests">
                        <Select
                            mode="multiple"
                            placeholder="Select Tests"
                            disabled={disableTests}
                            onChange={handleTestsChange}
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                                const t = tests.find(t => t.id === option.value);
                                const searchString = `${t.name} ${t.lab?.name || ""} ${t.b2c_price}`.toLowerCase();
                                return searchString.includes(input.toLowerCase());
                            }}
                        >
                            {tests.map(t => (
                                <Option key={t.id} value={t.id}>
                                    {`${t.name} - ${t.lab?.name || "No Lab"} - ${t.b2c_price}₹`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    {/* Multi-select Packages */}
                    <Form.Item label="Packages" name="packages">
                        <Select
                            mode="multiple"
                            placeholder="Select Packages"
                            disabled={disablePackages}
                            onChange={handlePackagesChange}
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                                const p = packages.find(p => p.id === option.value);
                                const searchString = `${p.name_of_package} ${p.lab_name || ""} ${p.b2c_price}`.toLowerCase();
                                return searchString.includes(input.toLowerCase());
                            }}
                        >
                            {packages.map(p => (
                                <Option key={p.id} value={p.id}>
                                    {`${p.name_of_package} - ${p.lab_name || "No Lab"} - ${p.b2c_price}₹`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
}

export default AddOrderItemModal;
